import React, { createContext, useContext, useMemo } from "react";
import { calculateBorderPadding, resolveCellBorders } from "./resolve-cell-borders.js";
const TableBordersContext = createContext(null);
const TableBordersProvider = ({
  tableNode,
  isRTL,
  children
}) => {
  const cellSpacing = tableNode.tableData?.cellSpacing ?? 0;
  const value = useMemo(() => {
    const borders = resolveCellBorders(tableNode, { drawDefaultGrid: true, cellSpacing });
    const borderPadding = calculateBorderPadding(tableNode);
    return { borders, cellSpacing, isRTL, borderPadding };
  }, [tableNode, cellSpacing, isRTL]);
  return /* @__PURE__ */ React.createElement(TableBordersContext.Provider, { value }, children);
};
function useCellBorders(cellId) {
  const context = useContext(TableBordersContext);
  if (!context) return null;
  return context.borders.get(cellId) || null;
}
function useTableBordersContext() {
  return useContext(TableBordersContext);
}
export {
  TableBordersProvider,
  useCellBorders,
  useTableBordersContext
};
//# sourceMappingURL=table-borders-context.js.map
